module.exports = __webpack_public_path__ + "img/slide3.a6f060da.png";